import type { IData } from "~/interfaces";
import { formatUserId } from "~/utils/crm";

const data: IData = getThemeData();

export default defineNuxtPlugin(() => {
    return {
        provide: {
            crmLoadClientData: async <T>(controlField: string, loadDevData: boolean = false,): Promise<T> => {

                if (loadDevData) {
                    const { FAKE_CLIENT_DATA } = await import(`~/themes/${data.theme}/data/fakeClientData.ts`);
                    const { PRECOMPILED_DATASET } = await import(`~/themes/${data.theme}/data/precompiledDataset.ts`);
                    const clientData = FAKE_CLIENT_DATA as T;
                    
                    
                    Object.keys(PRECOMPILED_DATASET).forEach((key) => {
                        updateStateValue(key, PRECOMPILED_DATASET[key as keyof typeof PRECOMPILED_DATASET]);
                    });
                    updateStateValue('isFakeDatasetActive', true); 

                    if(clientData && Object.hasOwn(clientData, controlField) ) {
                        return Promise.resolve(clientData);
                    } else {
                        return Promise.reject('Missing control field in fake data payload');
                    }
                }
                
                
                const userId = getStateValue("userId");
                const codeCampaign = getStateValue("codeCampaign");
                const trackCode = getStateValue("trackCode");

                return new Promise((resolve, reject) => {

                    if (!userId || !codeCampaign) reject(false);

                    $fetch(
                        `${data.endpoints.crm as string}/track/dem-info-secure`,
                        {
                            method: "POST",
                            body: {
                                userId: formatUserId(userId),
                                codeCampaign,
                                trackCode
                            },
                        }
                    ).then((response) => {
                        const clientData = response as T 
                        if(clientData && Object.hasOwn(clientData, controlField) )
                            resolve(clientData)
                        else
                            reject('Missing data from CRM payload')
                    })
                    .catch(function() {
                        reject(false)
                    })
                })

            }
        }
    }
})

